import { Brightness7Icon } from './Brightness7Icon';

/**
 * author: Google
 * id 014CCAA3-4B30-4C3D-921C-078A078A5198
 * name brightness-7
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/brightness-7.svg
 * tags
 * - Home Automation 
 */
export const BrightnessHighIcon = Brightness7Icon;
export default BrightnessHighIcon